import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../reducers/user';
import styles from '../styles/form.scss';
const UserLevelError = () => {
    const dispatch = useDispatch();
    const logoSrc = useSelector((state) => state.branding.partnerLogoSrc || '');
    // TODO correct brand name here
    return (React.createElement("div", { className: styles.background },
        React.createElement("div", { className: styles.container },
            React.createElement("img", { alt: 'Logo', className: styles.logo, src: logoSrc }),
            React.createElement("div", { className: styles.form },
                React.createElement("div", { className: styles.form_content },
                    React.createElement("h2", { className: styles.title_smaller }, 'To use Communicator please log in as a customer or an extension user.'),
                    React.createElement("div", { className: styles.button_container },
                        React.createElement("button", { className: styles.btn__primary, onClick: () => {
                                dispatch(logout());
                            } }, "Log out")))))));
};
export default UserLevelError;
